export const BUSINESS = {
  name: "STAR AVG ENTERPRISE",
  address:
    "Gali no. 4, G-02, UPSIDC, near Mahindra Showroom, Block F, Site IV, Surajpur Site 4, Greater Noida, Uttar Pradesh 201310",
  phone: "+91 95828 87899",
  phoneHref: "tel:+919582887899",
  rating: "4.9",
  reviewCount: "27+",
  mapsEmbed:
    "https://www.google.com/maps?q=STAR+AVG+ENTERPRISE,+G-02,+UPSIDC,+Site+IV,+Surajpur+Site+4,+Greater+Noida,+Uttar+Pradesh+201310&output=embed",
  mapsLink:
    "https://www.google.com/maps/search/?api=1&query=STAR+AVG+ENTERPRISE+Surajpur+Site+4+Greater+Noida",
  photosLink:
    "https://www.google.com/maps/place/STAR+AVG+ENTERPRISE/@28.4552057,77.528746,3a,75y,90t/data=!3m8!1e5!3m6!1sCIABIhAxAZhQCTqPjcPea82RVwQC!2e10!3e10!6shttps:%2F%2Flh3.googleusercontent.com%2Fgps-cs-s%2FAHRPTWmXSkGyk31i1ORbh03FDCqXxBLQ1rtE86RtVHE_Kb8vmjbAvHVwO-LkZHeRawCFKLwVyfJGJnmTHXRXbu-vQ6sRYYiGk5Mt8YyMzdNwJ1gyrseKRcQZLKgXjFieRjmRLzdOXyndfcx7yD1S%3Dw203-h360-k-no!7i478!8i850!4m7!3m6!1s0x390cc1b79b891291:0xc7bef1a46a6791ee!8m2!3d28.4551581!4d77.5287844!10e5!16s%2Fg%2F11lgy04tyy?hl=en",
};

export const SERVICES = [
  { n: "01", title: "Interior Design", tag: "Concepts, layouts & material stories" },
  { n: "02", title: "Interior Construction", tag: "Turnkey civil & structural work" },
  { n: "03", title: "Interior Fitting", tag: "Precision fitting & finishing" },
  { n: "04", title: "Furniture Manufacturing", tag: "Built to measure, made to last" },
  { n: "05", title: "Modular Home Building", tag: "Modular structures, end to end" },
  { n: "06", title: "Modular Home Dealing", tag: "Supply, delivery & installation" },
  { n: "07", title: "Kitchen Furniture", tag: "Cabinets, counters & storage" },
  { n: "08", title: "Kitchen Remodeling", tag: "From layout to last tile" },
  { n: "09", title: "Kitchen Supply", tag: "Fittings, hardware & surfaces" },
  { n: "10", title: "Custom Woodworking", tag: "Bespoke pieces, made to order" },
];

export const IMAGES = {
  hero: "https://images.pexels.com/photos/7148841/pexels-photo-7148841.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  living: "https://images.pexels.com/photos/7836571/pexels-photo-7836571.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  scandi: "https://images.pexels.com/photos/19966766/pexels-photo-19966766.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  kitchen:
    "https://images.unsplash.com/photo-1632583824020-937ae9564495?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxtaW5pbWFsaXN0JTIwbHV4dXJ5JTIwbW9kdWxhciUyMGtpdGNoZW58ZW58MHx8fHwxNzg2OTg3MDI4fDA&ixlib=rb-4.1.0&q=85",
  closet: "https://images.pexels.com/photos/6580395/pexels-photo-6580395.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  wardrobe: "https://images.pexels.com/photos/7061419/pexels-photo-7061419.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  kitchenSleek: "https://images.pexels.com/photos/7515855/pexels-photo-7515855.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  kitchenCopper: "https://images.pexels.com/photos/2089696/pexels-photo-2089696.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  kitchenMarble: "https://images.pexels.com/photos/11262210/pexels-photo-11262210.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

// Verbatim from the Google Business profile (limited public view, 2026-08-18)
export const GOOGLE_REVIEWS = [
  {
    name: "Sophiya Qaisar",
    meta: "Google review · 4 years ago",
    text: "I love the finishing of all my wooden work. The team is so professional. They are open to listen to your requirements. I achieved 100% what I dreamt of my kitchen, that too on committed time.",
  },
  {
    name: "Yash Yadav",
    meta: "Google review · Local Guide",
    text: "Hats off to the whole team. Timely delivered the task. Have wide ranges of design and laminates.",
  },
  {
    name: "Ritu Jindal",
    meta: "Google review · 5 years ago",
    text: "I got my Modular Kitchen, Modular Wardrobes, TV units and many other customised woodworks from them. They provide good quality work at reasonable price.",
  },
  {
    name: "Amit Sharma",
    meta: "Google review",
    text: "They have done Modular kitchen for me, I am fully satisfied with the work/services, I would definitely recommend them, Oh I did one :)",
  },
];
